import getOr from "lodash/fp/getOr";
import { RootState as RS } from "../types";
import { SLoginSlice } from "./types";

export const getLoginSlice = (s: RS): SLoginSlice => s.login;
export const getAuthentication = (s: RS) => getLoginSlice(s).authentication;
export const getIsLoginLoading = (s: RS) => getLoginSlice(s).isLoading;

export const getHideLogin = (s: RS) =>
  getOr(true, "hideLogin", getAuthentication(s)) as boolean;

export const getIsUserAdmin = (s: RS) =>
  getOr(false, "isUserAdmin", getAuthentication(s)) as boolean;

export const getUser = (s: RS) => getAuthentication(s).user;
export const getUserId = (s: RS) => getAuthentication(s).user?.userId;
export const getUserLogin = (s: RS) => getAuthentication(s).user?.login;
export const getIsLoggedOut = (s: RS) => !getAuthentication(s).user;
